import React, { use, useState } from 'react';

import { buttonProps } from 'src/components/layout/redesign/career-header-desktop/career-header-helper';
import HeaderMobile from 'src/components/layout/redesign/header-mobile';
import { CareerCmsContent } from 'src/content/career-content';
import { SiteContext } from 'src/context/site-context';

type CareerHeaderMobileProps = {
  forceMobileHeader?: boolean;
  forcePromoRibbonVisible?: boolean;
};

const CareerHeaderMobile = ({
  forceMobileHeader = false,
  forcePromoRibbonVisible: _forcePromoRibbonVisible = false,
}: CareerHeaderMobileProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { buildType, language } = use(SiteContext);

  const { careerHeaderContent } = use(CareerCmsContent);

  return (
    <HeaderMobile
      headerContent={careerHeaderContent.careerHeader}
      forceMobileHeader={forceMobileHeader}
      primaryButton={buttonProps(
        careerHeaderContent?.careerHeader.headerButtonPrimary,
        buildType,
        'Primary Button - Navigation',
        'Career Mobile Header',
        language,
        setIsMobileMenuOpen
      )}
      secondaryButton={buttonProps(
        careerHeaderContent?.careerHeader.headerButtonSecondary,
        buildType,
        '"Secondary Button" - Navigation',
        'Career Mobile Header',
        language,
        setIsMobileMenuOpen
      )}
      isMenuOpen={isMobileMenuOpen}
      setMenuOpen={setIsMobileMenuOpen}
    />
  );
};

export default CareerHeaderMobile;
